import type { QueryClient } from '@tanstack/react-query';

/** Include list keys whose user ID is nested in query parameters. */
export function invalidateProfileQueries(client: QueryClient, userId: string): void {
  const roots = new Set(['enrollments', 'registrations', 'users', 'profile', 'me']);
  void client.invalidateQueries({
    predicate: query =>
      roots.has(String(query.queryKey[0])) ||
      query.queryKey.some(
        part =>
          part === userId ||
          (typeof part === 'object' && part !== null && 'userId' in part && part.userId === userId)
      ),
  });
}
